/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCardFragment, CardFragment, FullCardFragment} from '@amblique/contentful/app/contentful/fragments/card';

/**
 * Get a single Card by ID (base - scalars only)
 */
export const getBaseCardById = gql`
  ${BaseCardFragment}

  query GetBaseCardById($id: String!, $locale: String!, $preview: Boolean) {
    card(id: $id, locale: $locale, preview: $preview) {
      ...BaseCardFragment
    }
  }
`;

/**
 * Get a single Card by ID (standard - 1 level deep)
 */
export const getCardById = gql`
  ${CardFragment}

  query GetCardById($id: String!, $locale: String!, $preview: Boolean) {
    card(id: $id, locale: $locale, preview: $preview) {
      ...CardFragment
    }
  }
`;

/**
 * Get a single Card by ID (full - 2 levels deep)
 */
export const getFullCardById = gql`
  ${FullCardFragment}

  query GetFullCardById($id: String!, $locale: String!, $preview: Boolean) {
    card(id: $id, locale: $locale, preview: $preview) {
      ...FullCardFragment
    }
  }
`;

/**
 * Get all Card entries with pagination (base - scalars only)
 */
export const getBaseCards = gql`
  ${BaseCardFragment}

  query GetBaseCards(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CardOrder]
    $where: CardFilter
    $preview: Boolean
  ) {
    cardCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseCardFragment
      }
    }
  }
`;

/**
 * Get all Card entries with pagination (standard - 1 level deep)
 */
export const getCards = gql`
  ${CardFragment}

  query GetCards(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CardOrder]
    $where: CardFilter
    $preview: Boolean
  ) {
    cardCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...CardFragment
      }
    }
  }
`;

/**
 * Get all Card entries with pagination (full - 2 levels deep)
 */
export const getFullCards = gql`
  ${FullCardFragment}

  query GetFullCards(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CardOrder]
    $where: CardFilter
    $preview: Boolean
  ) {
    cardCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullCardFragment
      }
    }
  }
`;
